import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Grid,
  Stack,
  Pagination,
} from "@mui/material";
import { MdDelete, MdVisibility } from "react-icons/md";
import axios from "axios";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    date: "",
  });

  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("https://ecom-api.applligentdemo.com/admin/users", {
        headers: {
          Authorization: `${token}`,
        },
      });

      const users = res.data.users || []; // Correct extraction
      setUsers(users);
      setFilteredUsers(users);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    let filtered = [...users];

    if (filters.name) {
      filtered = filtered.filter((u) =>
        u.name?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    if (filters.email) {
      filtered = filtered.filter((u) =>
        u.email?.toLowerCase().includes(filters.email.toLowerCase())
      );
    }

    if (filters.date) {
      filtered = filtered.filter(
        (u) => new Date(u.createdAt).toISOString().slice(0, 10) === filters.date
      );
    }

    setFilteredUsers(filtered);
    setPage(1); // Reset page on filter change
  }, [filters, users]);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await axios.delete(`https://ecom-api.applligentdemo.com/user/deleteUser/${id}`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        fetchUsers();
      } catch (err) {
        console.error("Error deleting user:", err);
      }
    }
  };

  return (
    <>
      {/* Filters */}
      <Paper sx={{ padding: 2, marginBottom: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Name"
              fullWidth
              value={filters.name}
              onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Email"
              fullWidth
              value={filters.email}
              onChange={(e) =>
                setFilters({ ...filters, email: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Registered Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date}
              onChange={(e) => setFilters({ ...filters, date: e.target.value })}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Users Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#A7C1A8" }}>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>User ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Registered At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers
              .slice((page - 1) * rowsPerPage, page * rowsPerPage)
              .map((user, index) => (
                <TableRow key={user._id}>
                  <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{user._id}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell>
                    {new Date(user.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {/* <IconButton
                      onClick={() =>
                        (window.location.href = `/view-user/${user._id}`)
                      }
                    >
                      <MdVisibility />
                    </IconButton> */}
                    <IconButton onClick={() => handleDelete(user._id)}>
                      <MdDelete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

            {filteredUsers.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No users found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Stack spacing={2} alignItems="center" mt={2}>
        <Pagination
          count={Math.ceil(filteredUsers.length / rowsPerPage)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </>
  );
};

export default UserList;
